export enum PlayerPositionEnum {
	QB = "QB",
	WR = "WR",
	RB = "RB",
	OL = "OL",
	DL = "DL",
	LB = "LB",
	DB = "DB",
	K = "K",
	P = "P",
	ST = "ST",
}

export enum Language {
	English = "en",
	French = "fr",
}

export enum RequestStateType {
	Loading,
	Success,
	Error,
	Idle,
}

export enum VotingStatus {
	Opened = "opened",
	Closed = "closed",
}

export enum LinksType {
	FIRST,
	SECOND,
	WITH_IMAGE,
	EMPTY,
}

export enum ShareTarget {
	Facebook = "fb",
	Twitter = "tw",
	Native = "native",
}

export enum ShareType {
	General = "general",
}

export enum EnvEnum {
	Development = "uat",
	PreProd = "preprod",
	Production = "production",
}

export enum PlayerPoolFilterStats {
	PassTouchdowns = "passingTouchdowns",
	ReceivingTouchdowns = "receivingTouchdowns",
	RushingTouchdowns = "rushingTouchdowns",
	PassYards = "passingYards",
	ReceivingYards = "receivingYards",
	RushingYards = "rushingYards",
	Sacks = "sacks",
	DefensiveTackles = "tackles",
	Interceptions = "interceptions",
	DefensiveTacklesForLoss = "tacklesForLoss",
	FieldGoalsMade = "fieldGoalsMade",
	FieldGoalPercentage = "fieldGoalsPct",
	GamesPlayed = "gamesPlayed",
	// GamesStarted = "gamesStarted",
	AveragePuntYards = "averageYards",
	PuntYards = "puntYards",
	ReturnTouchdowns = "returnsTouchdowns",
	SpecialTeamsTackles = "specialTeamsTackles",
}

export enum DetailsModalTabs {
	Overview,
	News,
	Stats,
}

export enum GameType {
	AllStar = "allStars",
	FanFavorite = "fanFavorite",
}

export enum DirectionFilter {
	High,
	Low,
}

export enum StatsTopTab {
	Offence = "offence",
	Defence = "defence",
	Special = "special",
}

export enum StatsSubTab {
	Passing = "passing",
	Rushing = "rushing",
	Receiving = "receiving",
}

export enum TeamPosition {
	DF = "defense",
	Flex = "flex",
}

export enum StatsType {
	Player,
	Team,
	Pos,
	PassingTouchdowns,
	RushingTouchdowns,
	ReceivingTouchdowns,
	PassingYards,
	RushingYards,
	ReceivingYards,
	Tackles,
	Sacks,
	FumblesForced,
	Interceptions,
}

export enum FilterPositions {
	QB = PlayerPositionEnum.QB,
	WR = PlayerPositionEnum.WR,
	RB = PlayerPositionEnum.RB,
	Flex = TeamPosition.Flex,
	DF = TeamPosition.DF,
}
